import { render, staticRenderFns } from "./AuthLogs.vue?vue&type=template&id=0bcf6e1b&scoped=true"
import script from "./AuthLogs.vue?vue&type=script&lang=js"
export * from "./AuthLogs.vue?vue&type=script&lang=js"
import style0 from "./AuthLogs.vue?vue&type=style&index=0&id=0bcf6e1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf6e1b",
  null
  
)

export default component.exports